import React, { useState, useEffect } from "react";
import { SeasonalColumns } from "./OffersTableData";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import ConfirmationATM from "../../../../../../Common/ConfirmationATM";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getBaseUrl } from "../../../../../../Redux/Config/AppConfig";
import { useLocation } from "react-router-dom";
import { hasDeleteAccess, hasEditAccess } from "../../../../../../Common/CheckAccess";

const SeasonalsTable = ({ setSelectedOffer, listUpdated }) => {
  const BaseUrl = getBaseUrl();
  const dispatch = useDispatch();
  const location = useLocation();

  const roomTypeFromQuery = new URLSearchParams(location.search).get("room_type");

   const [permissions, setPermissions] = useState([]);
      
        const existingPermissions = localStorage.getItem("checkPermission");
      
        useEffect(() => {
          if (existingPermissions != undefined) {
            const parsedData = JSON.parse(existingPermissions);
            setPermissions(parsedData);
          }
        }, [existingPermissions]);

  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("Room type");
  const [islistDataLoading, isSetListDataLoading] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});

  // Apply query param filter on mount
  useEffect(() => {
    if (roomTypeFromQuery) {
      setGlobalFilter(roomTypeFromQuery);
      setGloablFilterType("Room type");
    }
  }, [roomTypeFromQuery]);

  useEffect(() => {
    fetchData();
  }, [pageSize, currentPage, globalFilter, gloablFilterType, listUpdated,permissions]);
  
  const handleDelete = (selectData) => {
    setSelectedUser(selectData);
    setShowDeleteDialog(true);
  };

  const fetchData = async () => {
    isSetListDataLoading(true);
    const params = new URLSearchParams();
    params.set("page", currentPage);
    params.set("limit", pageSize);

    if (globalFilter) {
      if (gloablFilterType === "Offer name") {
        params.set("offer_name", globalFilter);
      } else if (gloablFilterType === "Room type") {
        params.set("room_type", globalFilter);
      }
    }

    try {
      let token = localStorage.getItem("token");
      let hotel_id = localStorage.getItem("hotel_id");

      const res = await fetch(`${BaseUrl}/room/offer/all?hotel_id=${hotel_id}&${params}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      const response = await res.json();
      const allOffers = response?.data?.data || [];
      const total = response?.data?.pagination?.totalResults || 0;
      setTotalEntries(total);

      const transformed = allOffers.map((data) => ({
        offer_name: data.offer_name || "N/A",
        room_type: data.room_type || "N/A",
        offer_type: data.offer_type || "N/A",
        valid_date_from: data.valid_date_from?.split("T")[0],
        valid_date_to: data.valid_date_to?.split("T")[0],
        discount_value: data.discount_value || "N/A",
        actions: (
          <>
            {(hasDeleteAccess(permissions, "rooms") || hasDeleteAccess(permissions, "front_desk")) && <button
              className="btn"
              data-toggle="modal"
              data-target="#deleteGuest"
              onClick={() => handleDelete(data)}
            >
              <i className="bi bi-trash text-danger"></i>
            </button>}
            <button
              data-bs-toggle="offcanvas"
              data-bs-target="#add-offer"
              aria-controls="add-offer"
              className="btn"
              disabled={!(hasEditAccess(permissions, "rooms") || hasEditAccess(permissions, "front_desk"))}
              onClick={() => setSelectedOffer(data)}
            >
              <i className="bi bi-pencil text-primary"></i>
            </button>
          </>
        ),
      }));

      setData(transformed);
    } catch (err) {
      console.error("Fetch offers failed", err);
    } finally {
      isSetListDataLoading(false);
    }
  };

  const confirmDelete = async () => {
    try {
      let token = localStorage.getItem("token");

      await fetch(`${BaseUrl}/room/offer/${selectedUser?.id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });
      toast.success("Data deleted successfully!");
      setShowDeleteDialog(false);
      fetchData();
    } catch (error) {
      toast.error("Something went wrong!");
      setShowDeleteDialog(false);
    }
  };

  const totalPages = Math.ceil(totalEntries / pageSize);

  return (
    <>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setCurrentPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        flage="offers"
        filtersOptions={["Offer name", "Room type"]}
      />

      <DataTable
        columns={SeasonalColumns}
        data={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        isLoading={islistDataLoading}
      />

      <DataTableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />

      <ConfirmationATM
        show={showDeleteDialog}
        onClose={() => {
          setShowDeleteDialog(false);
          setSelectedUser("");
        }}
        onConfirm={confirmDelete}
        message={`Are you sure you want to delete offer ${selectedUser?.offer_name}?`}
      />
    </>
  );
};

export default SeasonalsTable;
